import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {AuthService} from '../auth/auth.service';
import {IResponse} from '../service';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
  }

  getGroupList(): Observable<IResponse> {
    return this.http.get<IResponse>(`${environment.apiBaseUrl}/companies/group`);
  }

  createGroup(body: any): Observable<IResponse> {
    return this.http.post<IResponse>(`${environment.apiBaseUrl}/companies/group`, {
      ...body
    });
  }

  renameGroup(body: any): Observable<IResponse> {
    return this.http.put<IResponse>(`${environment.apiBaseUrl}/companies/group`, {
      ...body
    });
  }

  deleteGroup(id: string): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/companies/group/${id}`);
  }
}
